/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2023-11-21 10:49:56
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-06-11 08:52:43
 */
import { useAppStore } from '@/store';
import Layout from '@/layout/index.vue';
import ErrorPage from '@/views/error/404.vue';
// 根级菜单
const rootRouter: any = {
  path: '/',
  name: '',
  component: Layout,
  children: [],
};
// 添加动态路由
export const addRoutes = (menuStore: any, router: any) => {
  const appStore = useAppStore();
  if (menuStore.initMenus && menuStore.initMenus.length > 0) {
    //首先判断传入的 store中是否时存在数据的，一般在获取数据时就会判断数据是否正确，且pinia增加持久化，故此地也可不要if判断
    const routesData = JSON.parse(JSON.stringify(menuStore.initMenus));
    //深拷贝数据，慎用，上线之后项目会报错，大致是因为循坏加载constructor
    const modules = import.meta.glob('../views/**/*.vue');
    //vue3 新写法，目的是为了后续处理数据中的组件引入路径
    // rootRouter.children = recursiveRoutes(routesData, '0', modules);
    rootRouter.children = recursiveRoutes(routesData[0].children, routesData[0].id, modules);
    appStore.setMenuList(rootRouter);
  }
  router.addRoute({
    //在所有的路由动态添加完毕后，需再次添加404页面，注意vue3新写法
    path: '/:pathMatch(.*)*',
    name: '404',
    component: ErrorPage,
    meta: {
      title: '无法找到该页面',
      layout: false,
    },
  });
  let redirect = '';
  let index = 0;
  /**
   * redirect路径拼接
   * @param {*} route 路由对象
   */
  let concatPath = (route) => {
    redirect = `${redirect}${index > 1 ? '/' : ''}${route.path}`;
    // console.log(route, redirect);
    index++;
    if (route.children && route.children.length) {
      concatPath(route.children[0]);
    }
  };
  concatPath(rootRouter);
  rootRouter.redirect = redirect;
  // console.log('menuList:', rootRouter);
  // if(appStore.currentMenu.length!=1){
  //   appStore.setCurrentMenu([rootRouter.redirect.split('/')[1]]);
  // }
  router.addRoute(rootRouter);
};

// 清除动态路由
export const clerRoutes = (menuStore: any, router: any) => {
  if (menuStore.initMenus && menuStore.initMenus.length > 0) {
    menuStore.initMenus.forEach((item: any) => {
      router.removeRoute(item.name);
    });
    menuStore.clearMenuList();
    //直接调用menu store中定义好的action函数
  }
};

// 递归遍历路由数据
const recursiveRoutes = (tree: any[], parent: string, modules) => {
  const tmpRouter: any[] = [];
  tree.forEach((item) => {
    if (item.pid === parent && item.types == 1 && item.urlLink) {
      //只生成菜单路由
      const currentRouter = {
        // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
        path: `${item.urlLink}`,
        // path: '*',
        menuPath: `${item.urlLink}`,
        // 路由名称，建议唯一
        name: item.title,
        // component: item.component == 'Layout'? import('../components/Layout/index.vue') : modules[`../views/${item.component}.vue`],
        component: item.component == 'Layout' ? Layout : modules[`../views/${item.component}.vue`],
        // component: item.component,
        oldComponent: item.component,
        pid: item.pid,
        meta: {
          permission: [item.permissions],
          server: item.server?.split(',') || null,
        },
        icon: item.icon,
      };

      item.redirect && (currentRouter['redirect'] = item.redirect);
      if (item.children && item.children.length > 0) {
        // 保存按钮、字段权限
        let permission: any[] = [...currentRouter.meta.permission];
        item.children.forEach((el) => {
          // console.log(el.permissions);
          el.permissions && permission.push(el.permissions);
        });
        currentRouter.meta.permission = permission;
        //深拷贝数据，慎用，上线之后项目会报错，大致是因为循坏加载constructor
        const modules = import.meta.glob('../views/**/*.vue');
        currentRouter['children'] = recursiveRoutes(item.children, item.id, modules);
      }
      tmpRouter.push(currentRouter);
    }
  });

  return tmpRouter.length > 0 ? tmpRouter : null;
};
